export default __webpack_public_path__ + "static/left_c2a_arrow-57f62561a1caf0d8c6180b673434dbe0.png";